<div class="ui-g policy-container">
  <div class="header header-background" id="policyPageHeader">
    <img alt="Logo" class="logo-image" src="assets/images/logo-upperleft.png">
    <div class="logo-title">
      {{'app.service_portal' | translate}}
    </div>
  </div>
  <div class="policy-body">
    <div [innerHTML]="('privacy-policy.heading' | translate)"></div>
    <div [innerHTML]="('privacy-policy.content' | translate)"></div>
  </div>
</div>
